/* eslint-disable no-unused-expressions */
/* eslint-disable mdx/no-unused-expressions */
import { MDXProvider } from '@mdx-js/react'
import {
  Col,
  Container,
  Row,
  Tooltip,
  Button,
  Icon,
  Tabs as ArchTabs,
  AccordionRow,
  Table as PayPalTable,
  Toast,
  Badge,
  Banner,
  Alert,
} from '@paypalcorp/pp-react'
import { graphql, Link } from 'gatsby'
import { MDXRenderer } from 'gatsby-plugin-mdx'
import moment from 'moment'
import React, { useEffect, useLayoutEffect, useState, useCallback } from 'react'
import {
  CodeBlock,
  CodeBlockWrapper,
  NewCodeBlockWrapper,
  RunInPostman,
  YouTubeColumnLayout,
  YoutubeVideo,
  Pills,
  UITabs,
  NewCodeBlock,
  MultipartyForm,
  IntegrationCards,
  CompGrid,
  ImageLayout,
  ExperimentHoc,
} from '../components/layout'
import BreadCrumbs from '../components/layout/BreadCrumbs'
import CountryDropdown from '../components/layout/CountryDropdown/countryDropdown'
import Table from '../components/icons/Table'
import Layout from './layout'
import DropdownUtil from '../utils/DropdownUtil'
import { Tab, Tabs } from '../utils/Tabs'
import { NewCodeTab, NewCodeTabs } from '../utils/NewCodeTabs'
import ContentAccordion from '../utils/ContentAccordion'
import { ContentTabs, ContentTab } from '../utils/ContentTabs'
import MarkdownLink from '../utils/Links'
import ImageLink from '../utils/Images'
import Lightbox from 'react-image-lightbox'
import { DocumentIcon } from '../../src/components/layout/Icons/DocumentIcon'
import { CommunityIcon } from '../../src/components/layout/Icons/CommunityIcon'
import { PlayButton } from '../../src/components/layout/Icons/PlayButton'
import { FaqIcon } from '../../src/components/layout/Icons/FaqIcon'
import { CodeIcon } from '../../src/components/layout/Icons/CodeIcon'
import { OrdersIcon } from '../../src/components/layout/Icons/OrdersIcon'
import { ArrowIcon } from '../../src/components/layout/Icons/ArrowIcon'
import { CheckoutIcon } from '../../src/components/layout/Icons/CheckoutIcon'
import { CheckIcon } from '../../src/components/layout/Icons/CheckIcon'
import { SDKIcon } from '../../src/components/layout/Icons/SDKIcon'
import { APMIcon } from '../../src/components/layout/Icons/APMIcon'
import { PayLaterIcon } from '../../src/components/layout/Icons/PayLaterIcon'
import { SecurityIcon } from '../../src/components/layout/Icons/SecurityIcon'
import { VenmoIcon } from '../../src/components/layout/Icons/VenmoIcon'
import { SandboxIcon } from '../../src/components/layout/Icons/SandboxIcon'
import { PartnerIcon } from '../../src/components/layout/Icons/PartnerIcon'
import { BellIcon } from '../../src/components/layout/Icons/BellIcon'
import ImageContainer from '../components/ImageContainer'
import { SectionInView } from '../components/SectionInView'
import 'react-image-lightbox/style.css'
/*
  Base Template for each markdown pages.
*/
import '../css/ppvx.css'
import '../css/fonts-and-normalize.css'
import '../css/docs.css'
import './index.css'

import CheckoutGraphic from '../components/icons/CheckoutGraphic'
import { useApplicationContext } from '../provider'
import { Spacer } from '../components/layout/Spacer'
import { PaymentsDropdown } from '../components/layout/PaymentsDropdown'
import CreditCardGenerator from '../components/layout/CreditCardGenerator'
import NavigationTabs from '../components/layout/NavigationTabs'
import { SectionInViewContextProvider } from '../context/SectionInViewContext'

const displayCountryDropdown = '/pay-later/'

const vaultDropdownRoutes = [
  '/beta/vault/during-purchase/js-sdk/',
  '/beta/vault/during-purchase/orders-api/',
  '/beta/vault/purchase-later/',
]
const displayPaymentsDropdown = new RegExp(vaultDropdownRoutes.join('|'), 'gi')

const components = {
  CodeBlock,
  OrdersIcon,
  VenmoIcon,
  SecurityIcon,
  SandboxIcon,
  PartnerIcon,
  APMIcon,
  PayLaterIcon,
  ArrowIcon,
  CheckoutIcon,
  SDKIcon,
  CommunityIcon,
  PlayButton,
  FaqIcon,
  CodeIcon,
  ArchTabs,
  Link,
  Tab,
  Tabs,
  ContentTab,
  ContentTabs,
  NewCodeTab,
  NewCodeTabs,
  CodeBlockWrapper,
  Col,
  ExperimentHoc,
  NewCodeBlock,
  NewCodeBlockWrapper,
  Banner,
  BellIcon,
  Lightbox,
  Row,
  Container,
  Table,
  CheckoutGraphic,
  Tooltip,
  img: (props) => <ImageLink {...props} />,
  a: (props) => <MarkdownLink {...props} />,
  Spacer,
  RunInPostman,
  YouTubeColumnLayout,
  YoutubeVideo,
  Button,
  Icon,
  Pills,
  ContentAccordion,
  AccordionRow,
  Toast,
  CreditCardGenerator,
  NavigationTabs,
  DocumentIcon,
  Badge,
  SectionInView,
  ImageContainer,
  UITabs,
  PayPalTable,
  CheckIcon,
  MultipartyForm,
  IntegrationCards,
  CompGrid,
  ImageLayout,
  DropdownUtil,
  Alert,
}

const addAnchorsToTable = (tableRow) => {
  const list = Array.from(document.getElementsByTagName(tableRow))
  list.forEach((tr) => {
    let _anchorLink = tr.textContent.toLowerCase().trim().replace(/\s+/g, '-')
    tr.id = _anchorLink

    if (tr.textContent && tr.id) {
      if (
        tr.firstElementChild &&
        tr.firstElementChild.nodeName.toLowerCase() === `td`
      ) {
        let trChild = tr.firstElementChild
        if (trChild.childNodes.length) {
          tr.classList += `dx-anchor`

          let anchorLink = document.createElement(`a`)
          anchorLink.href = `#${_anchorLink}`
          anchorLink.setAttribute(`aria-hidden`, `true`)
          anchorLink.setAttribute(`pa-marked`, `1`)

          trChild.insertBefore(anchorLink, trChild.childNodes[0])
        }
      }
    }
  })
}

const emptyHeaders = (tableItem) => {
  let hideCount = 0
  let childCount = 0
  let tableHead = tableItem.firstElementChild

  if (tableHead && tableHead.nodeName.toLowerCase() === 'thead') {
    let tableRow = tableHead.firstElementChild
    if (tableRow && tableRow.nodeName.toLowerCase() === 'tr') {
      let thItem = tableRow.firstElementChild
      while (thItem && thItem.nodeName.toLowerCase() === 'th') {
        childCount++
        if (!thItem.textContent || thItem.textContent.trim() === '') {
          hideCount++
        }
        thItem = thItem.nextElementSibling
      }
    }
  } else if (tableHead && tableHead.nodeName.toLowerCase() === 'tbody') {
    let tableRow = tableHead.firstElementChild
    if (tableRow && tableRow.nodeName.toLowerCase() === 'tr') {
      let thItem = tableRow.firstElementChild
      while (thItem && thItem.nodeName.toLowerCase() === 'th') {
        childCount++
        if (!thItem.textContent || thItem.textContent.trim() === '') {
          hideCount++
        }
        thItem = thItem.nextElementSibling
      }
    }
  } else if (tableHead && tableHead.nodeName.toLowerCase() === 'colgroup') {
    let tableActualHead = tableHead.nextElementSibling
    if (tableActualHead && tableActualHead.nodeName.toLowerCase() === 'thead') {
      let tableRow = tableActualHead.firstElementChild
      if (tableRow && tableRow.nodeName.toLowerCase() === 'tr') {
        let thItem = tableRow.firstElementChild
        while (thItem && thItem.nodeName.toLowerCase() === 'th') {
          childCount++
          if (!thItem.textContent || thItem.textContent.trim() === '') {
            hideCount++
          }
          thItem = thItem.nextElementSibling
        }
      }
    }
  } else {
    return true
  }

  if (hideCount === childCount && hideCount > 0) {
    return true
  }

  return false
}

const addTableClasses = () => {
  const list = Array.from(document.getElementsByTagName('table'))

  list.forEach((tableItem) => {
    tableItem.classList.add('ppvx_table')
    tableItem.classList.add('ppvx_table-responsive-sm')
  })
}

const removeTableHeadingIfEmpty = () => {
  const list = Array.from(document.getElementsByTagName('table'))

  list.forEach((tableItem) => {
    if (emptyHeaders(tableItem)) {
      tableItem.classList.add('dx-table-lite')
    }
  })
}

const containsNumbers = (str) => {
  return /[0-9]/.test(str)
}

export default function Home(props) {
  const { setRightNav, user } = useApplicationContext()
  const [rightNavs, setRightNavs] = useState([])
  const userLoggedIn = user && user.loggedIn
  const isACDC =
    props.location.pathname === '/docs/checkout/advanced/integrate/'
  const isNewArchetype =
    props.location.pathname === '/docs/checkout/advanced/integrate/' ||
    props.location.pathname === '/api/rest/' ||
    props.location.pathname === '/docs/checkout/' ||
    props.location.pathname === '/beta/advanced-mobile/integrate-ios/' ||
    props.location.pathname === '/docs/multiparty/' ||
    props.location.pathname === '/docs/checkout/apm/apple-pay/'

  const addAnchors = (heading, rightNavHrefs = []) => {
    let newHeading
    const list = Array.from(document.getElementsByTagName(heading))
    list.forEach((h) => {
      let anchorLink = h.textContent.toLowerCase().trim().replace(/\s+/g, '-')
      let newAnchor = 'link-'
      newAnchor += anchorLink.replace(/[^A-Za-z]+/g, '')

      h.id = anchorLink
      if (h.textContent) {
        if (containsNumbers(h.textContent)) {
          if (isNewArchetype) {
            let firstHalf = h.textContent
              .substring(0, h.textContent.indexOf(' '))
              .slice(0, -1)
            let secondHalf = h.textContent.substring(h.textContent.indexOf(' '))
            newHeading = `<span class="archHeading">${firstHalf}</span><span>${secondHalf}</span>`
          } else {
            newHeading = h.textContent
          }
        } else {
          newHeading = ''
        }
        h.classList += 'dx-anchor'
        h.classList += isNewArchetype ? ' newArchetype' : ''
        h.innerHTML = `<span class="headingAnchorLinks" id="${newAnchor}"></span><a class="dx-anchor__icon" href="#${newAnchor}" aria-hidden="true" pa-marked="1" tabIndex="-1"></a> ${
          newHeading ? newHeading : h.textContent
        }`
        heading === 'h2' &&
          rightNavHrefs.push({ content: h.textContent, id: newAnchor, a: 'a' })
      }
      document.getElementById(h.id).addEventListener('click', function () {
        const rightNavs = document.querySelectorAll('.rightNav-anchor')
        Array.from(rightNavs).forEach((rightNav) => {
          const href = rightNav.getAttribute('href').substring(1)
          if (href === newAnchor && !rightNav.classList.contains(href)) {
            setRightNav(href)
          }
        })
      })
    })
    return rightNavHrefs
  }
  const removeClassOrNodeFromDom = useCallback(
    () =>
      window.document
        .querySelector('.sidebar-title')
        ?.classList.remove('.dx-anchor'),
    [],
  )

  useEffect(() => {
    removeClassOrNodeFromDom()
    return () => {}
  }, [removeClassOrNodeFromDom])

  useEffect(() => {
    const sidebarTitle = window.document
      .querySelector('.sidebar-title a')
      ?.remove()

    return sidebarTitle
  }, [])

  // picking all the h2 tags and adding an anchor to it.
  useLayoutEffect(() => {
    const anchorHeadings = ['h1', 'h2', 'h3', 'h4', 'h5']
    console.log('anchorHeadings', anchorHeadings)
    anchorHeadings.forEach((heading) => {
      const rightNavHrefs = addAnchors(heading)
      // eslint-disable-next-line mdx/no-unused-expressions
      rightNavHrefs.length && setRightNavs(rightNavHrefs)
    })

    const tableItems = ['tr']
    tableItems.forEach((tableRow) => {
      addAnchorsToTable(tableRow)
    })

    removeTableHeadingIfEmpty()
    addTableClasses()
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [])

  const {
    mdx: { frontmatter, body },
  } = props.data
  const filePath = props.data.mdx.fileAbsolutePath

  const isPayLater =
    filePath && filePath.includes(displayCountryDropdown) ? true : false
  const isPayWith =
    filePath && displayPaymentsDropdown.test(filePath) ? true : false

  /**
   **NOTE: Don't remove this, it is just a tweak
   **to make the PaymentsDropdown work
   **/
  displayPaymentsDropdown.test(filePath)

  let countrySelector = isPayLater ? <CountryDropdown /> : null
  let paymentSelector = isPayWith ? <PaymentsDropdown /> : null
  let subtitle = null
  if (
    frontmatter &&
    frontmatter.subtitle &&
    frontmatter.subtitle.trim() !== ``
  ) {
    subtitle = (
      <p className="dx-content-subtitle">
        {frontmatter && frontmatter.subtitle}
      </p>
    )
  }

  useEffect(() => {
    // Fire impression event to amplitude
    // camelCase is not allowed in FPTI Tags so using snake_case
    if (frontmatter.amplitude) {
      const [product, event_name, event_prop, event_value] =
        frontmatter.amplitude.split(',')
      const data = {
        product,
        event_name,
      }
      if (event_prop && event_value) {
        data.event_props = event_prop
        data[event_prop] = event_value
      }
      // eslint-disable-next-line mdx/no-unused-expressions
      // eslint-disable-next-line no-unused-expressions
      window?.PAYPAL?.analytics?.instance?.recordImpression({
        data,
      })
      if (window.fpti) {
        //clear the fpti data added above
        window.fpti.product = null
        window.fpti.event_name = null
        window.fpti.event_props = null
        window.fpti[event_prop] = null
      }
    }
  }, [frontmatter])

  const multiparty = props.location.pathname === '/docs/multiparty/'

  return (
    <Layout
      rightNav={rightNavs}
      leftNavBar={true}
      layout="dx-docs"
      activeNavLocal
      location={props.location}
      title={frontmatter.title}
      description={frontmatter.description}
      keywords={frontmatter.keywords}
      contentType={frontmatter.contentType}
      productStatus={frontmatter.productStatus}
      apiVersion={frontmatter.apiVersion}
      sdkVersion={frontmatter.sdkVersion}
      sIntegration={frontmatter.sIntegration}
      aIntegration={frontmatter.aIntegration}
      amplitude={frontmatter.amplitude}
      fileAbsolutePath={filePath}
      hideRightNav={isNewArchetype}
    >
      <div id="hashLinkContainer" />
      <main
        className={
          isNewArchetype
            ? 'content dx-content noRightNav-main'
            : 'content dx-content'
        }
        id={userLoggedIn ? 'Authed' : 'Unauthed'}
      >
        <div
          className={isNewArchetype ? 'archetypeHeader' : ''}
          style={isNewArchetype || isACDC ? { marginTop: '120px' } : {}}
        >
          <BreadCrumbs {...props} />
          <h1 className="dx-content-title ">
            {frontmatter && frontmatter.title}
          </h1>
          {subtitle}
          <p className="dx-status-wrapper">
            {frontmatter && frontmatter.contentType && !isNewArchetype && (
              <span className="dx-content-type">{frontmatter.contentType}</span>
            )}
            {frontmatter && frontmatter.contentType && isNewArchetype && (
              <Badge type="feature">{frontmatter.contentType}</Badge>
            )}
            {frontmatter && frontmatter.productStatus && !isNewArchetype && (
              <span className="dx-product-status">
                {frontmatter.productStatus}
              </span>
            )}
            {frontmatter && frontmatter.productStatus && isNewArchetype && (
              <Badge type="feature">{frontmatter.productStatus}</Badge>
            )}
            {frontmatter && frontmatter.sIntegration && (
              <span className="dx-sIntegration">
                {frontmatter.sIntegration}
              </span>
            )}
            {frontmatter && frontmatter.aIntegration && (
              <span className="dx-aIntegration">
                {frontmatter.aIntegration}
              </span>
            )}
            {frontmatter && frontmatter.date && (
              <span className="dx-product-lastUpdated">
                Last updated:{' '}
                {moment(frontmatter.date).format('MMMM Do YYYY, @ h:mm:ss a')}
              </span>
            )}
          </p>
          {countrySelector}
          {paymentSelector}
        </div>
        <br />
        <SectionInViewContextProvider>
          <MDXProvider components={components}>
            <MDXRenderer>{body}</MDXRenderer>
          </MDXProvider>
        </SectionInViewContextProvider>
        <div id="docsFeedback_bottomOfSection" />
      </main>
    </Layout>
  )
}

// query to get html and frontmatter
export const pageQuery = graphql`
  query ($fileAbsolutePath: String) {
    mdx(fileAbsolutePath: { eq: $fileAbsolutePath }) {
      body
      fileAbsolutePath
      frontmatter {
        title
        description
        subtitle
        keywords
        contentType
        productStatus
        apiVersion
        sdkVersion
        date
        sIntegration
        aIntegration
        amplitude
      }
    }
  }
`
